import { formatters } from "@garantidos/utils"

import { ltv } from "constants"

export const fields = {
  propertyValue: {
    type: "ids-currency",
    name: "property_value",
    label: "Valor do seu imóvel",
    ariaLabel:
      "Qual o valor do seu imóvel? Digite um valor entre R$ 52.000,00 e R$ 99.999.999,00",
    description: "Valor mínimo: R$ 52.000,00",
    rules: {
      minPropertyValue: 52000,
      maxPropertyValue: 99999999
    }
  },
  creditValue: {
    type: "ids-currency",
    name: "credit_value",
    label: "Valor do crédito que deseja",
    ariaLabel: (propertyValue) =>
      propertyValue
        ? `Qual o valor do crédito que você deseja? Digite um valor entre R$ 30.000,00 e ${formatters.toCurrency(
            propertyValue * ltv
          )}`
        : "",
    description: (propertyValue) =>
      propertyValue && propertyValue >= 52000 && propertyValue <= 99999999
        ? `Entre R$ 30.000,00 e ${formatters.toCurrency(propertyValue * ltv)}`
        : "Valor mínimo: R$ 30.000,00",
    rules: {
      minCreditValue: 30000,
      maxCreditValue: ltv
    }
  },
  financingTerm: {
    type: "ids-select",
    name: "financing_term",
    label: "Em quantas parcelas?",
    sendFormat: "month",
    fetchFormat: "year",
    description: "Digite o valor do bem pra ver o prazo",
    options: Array.from({ length: 20 }, (_, index) => index + 1).map(
      (number) => ({
        value: number,
        label: `${number} ${number > 1 ? "anos" : "ano"}`
      })
    )
  }
}
